export const dashboardText = {
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.5px",
  verticalAlign: "middle",
};

export const hideScrollbar = {
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    width: "0px",
    height: "0px",
    display: "none",
  },
};

export const thinScrollbar = {
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#c9d2d8",
    borderRadius: "999px",
  },
};
